<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <TestsTable :prices="pricesList"/>
        </div>
      </div>
      
    </div>
</template>
  
<script>
import axios from "axios";
import TestsTable from "./components/Table.vue";  
export default {
    name: "tables",
    components: {
        TestsTable,
    },
    data() {
        return {
            pricesList:[],
        };
    },
    methods:{
        async fetchPrices(config){
            let self=this;
            axios.get(this.$store.state.apiURL+'?action=list&object=view_prices&recperpage=all',config)
            .then((result)=>{
                console.log(result);
                this.pricesList=result.data.view_prices.map(item=>{return{id:item.id, code:item.code,description:item.description, active:item.active, discount:item.discount, tests:item.tests, total:item.total, first:item.first}});
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"Authorization": `Bearer ${token}`}};
        this.fetchPrices(config);
    },
};
</script>
  